import React, {Component} from 'react';
import { Select } from 'antd';
import _ from 'lodash'
import './style.scss'
const { Option } = Select;
class BankInput extends Component {
    constructor() {
        super();
        this.state = {
            // 所有银行
            banks: [],
            // 满足检索条件的银行
            loading: false,
        };
        this.keywordsFilters = [
            '银行'
        ];
    }

    componentDidUpdate(prevProps) {
        const { value, actions, flowId } = this.props;
        if ((prevProps.flowId !== flowId  && value) || (prevProps.value !== value)) {
            // this.isBanksLoaded = true;
            // 触发 支行组件夹在支行数据
           this.renderBankOPts();
        }
    }
    componentDidMount () {
        const { value, actions, flowId, source, } = this.props;
        if (value) {
            actions.searchBanks({ bankCode: value }, source).then(resData => {
                if (!resData.error) this.setState({banks: resData.payload && resData.payload.result || [] })
            });
        }

    }
    handleSearch = async ({bankName}) => {
        const { actions, source } = this.props;
        this.setState({loading: true})
        try {
            const { payload = {}, error = false  } = await actions.searchBanks({bankName}, source);
            const { result = [] } = payload;
            if (!error) this.setState({ banks: result });
        } catch (err) {
        } finally {
            this.setState({loading: false});
        }

    }

    handleChange = (val) => {
        const {  actions } = this.props;
        this.props.onChange && this.props.onChange(val); // 回传给表单
    }
    renderBankOPts = (bankCode) => {
        const { value, actions, source } = this.props;
        actions.searchBanks({ bankCode: value }, source).then(resData => {
            if (!resData.error) this.setState({banks: resData.payload && resData.payload.result || [] })
        });
    }

    render() {
        const { value, disabled } = this.props;
        const options = this.state.banks && this.state.banks.map(bank => <Option key={bank.bankCode} value={bank.bankCode}>{bank.bankName}</Option>);
        return (
          <Select
            placeholder='请输入关键字检索'
            showSearch
            value={ value }
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={_.debounce((val) => val && !this.keywordsFilters.includes(val) && this.handleSearch({bankName: val}), 1000)}
            onChange={this.handleChange}
            notFoundContent={null}
            defaultValue={value}
            loading={this.state.loading}
            disabled={disabled}
            
          >
            {options}
          </Select>
        )
    }
}
export default BankInput;